import React, { createContext, useContext } from 'react';

export type TokenCardToastFn = (props: {
  title: string;
  description?: string;
  variant?: 'default' | 'destructive';
  duration?: number;
}) => void;

/** Injected app services + subcomponents for cash token UI. */
export interface TokenCardDependencies {
  toast: TokenCardToastFn;
  user: { id?: string; _id?: string; username?: string } | null | undefined;
  config: {
    ui?: {
      cardIssuanceRules?: Record<string, { min: number; max: number }>;
    };
  } | null | undefined;
  boPaymentsApi: {
    getPrepaidCardForToken: (tokenKey: string) => Promise<unknown>;
  };
  updateTokenConditions: (
    tokenKey: string,
    body: { validity: import('@vaiu/token-ux').ValidityRedemptionFields }
  ) => Promise<unknown>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- app slot components vary by build
  PrepaidCard: React.ComponentType<any>;
  NFCPayment: React.ComponentType<any>;
  InvoicePaymentDecision: React.ComponentType<any>;
}

const TokenCardContext = createContext<TokenCardDependencies | null>(null);

export function TokenCardProvider({
  value,
  children,
}: {
  value: TokenCardDependencies;
  children: React.ReactNode;
}) {
  return <TokenCardContext.Provider value={value}>{children}</TokenCardContext.Provider>;
}

export function useTokenCardDeps(): TokenCardDependencies {
  const ctx = useContext(TokenCardContext);
  if (!ctx) {
    throw new Error('@vaiu/cash-token-card: TokenCardProvider is required around TokenCard');
  }
  return ctx;
}
